import * as React from "react";
import { SermonItem } from "./interfaces";
import { PreacherPage } from "../preachers/interfaces";
import { CategoryPage } from "../categories/interfaces";
import { setDebounce } from "../helpers/setDebounce";
import { FetchApi } from "../../FetchApi";
import { useHistory, useParams } from "react-router-dom";
import { FormHelper, ReactiveForm } from "../helpers/ReactiveForm";
import { requestHelper } from "../helpers/requestHelper";
import { Loading } from "../helpers/Loading";
import { BsEditor } from "../helpers/BsEditor";
import { Checkbox } from "../helpers/Checkbox";

export const CreateSermon = () => {
  const [preachers, setPreachers] = React.useState<PreacherPage | null>(null);
  const [categories, setCategories] = React.useState<CategoryPage | null>(null);
  const [subCategories, setSubCategories] = React.useState<CategoryPage | null>(null);
  const [selectedCategoryId, setSelectedCategoryId] =
    React.useState<string>("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] =
    React.useState<string>("");
  const history = useHistory();

  const retrievePreachers = (body = {}) => {
    setDebounce(
      () => {
        FetchApi.get<PreacherPage>({
          path: "preachers",
          body: { sorts: "-created_at", ...body },
        }).then((response) => {
          setPreachers(response);
        });
      },
      "preachers",
      500
    );
  };

  const retrieveCategories = (body = {}) => {
    FetchApi.get<CategoryPage>({
      path: "categories",
      body: { sorts: "-created_at", filters: "depth:0", ...body },
    }).then((response) => {
      setCategories(response);
    });
  };

  const retrieveSubCategories = (categoryId: string) => {
    if (!categoryId) {
      setSubCategories(null);
      setSelectedSubCategoryId("");
      return;
    }
    FetchApi.get<CategoryPage>({
      path: "categories",
      body: {
        sorts: "-created_at",
        filters: `parent_id:${categoryId}`,
        paginate: 1000000000000,
      },
    }).then((response) => {
      setSubCategories(response);
      setSelectedSubCategoryId("");
    });
  };

  React.useEffect(() => {
    retrievePreachers({ paginate: 1000000000000 });
    retrieveCategories({ paginate: 1000000000000 });
  }, []);

  React.useEffect(() => {
    retrieveSubCategories(selectedCategoryId);
  }, [selectedCategoryId]);

  function createSermon(event: FormHelper) {
    requestHelper({
      form: event,
      request: FetchApi.post<SermonItem>({
        path: `sermons`,
        body: event.value,
      }).then((m) => {
        history.push(`/sermons/${m.data.id}`);
        return m;
      }),
    });
  }

  return (
    <>
      <div className="d-flex p-2 p-md-4" style={{ minHeight: "100vh" }}>
        <div className="my-auto w-100">
          <div className="d-flex">
            <h2>اضافة خطبة</h2>
          </div>
          <ReactiveForm
            onSubmit={createSermon}
            valueAs={"json"}
            className="card my-3"
          >
            <button className="btn btn-primary btn-lg btn-floating">
              <i className="fas fa-save fa-fw" />
            </button>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      placeholder=""
                    />
                    <label>عنوان الخطبة</label>
                  </div>
                </div>
                <div className="col-md-6">
                  <Loading
                    loading={preachers}
                    render={() => (
                      <>
                        <div className="form-floating">
                          <select
                            className="form-select"
                            name="preacher_id"
                            placeholder=""
                          >
                            {preachers?.data?.map((preacher) => (
                              <option key={preacher.id} value={preacher.id}>
                                {preacher.name}
                              </option>
                            ))}
                          </select>
                          <label>الخطيب</label>
                        </div>
                      </>
                    )}
                  />
                </div>
                <div className="col-md-6 my-3">
                  <Loading
                    loading={categories}
                    render={() => (
                      <>
                        <div className="form-floating">
                          <select
                            className="form-select"
                            name="category_id"
                            placeholder=""
                            value={selectedCategoryId}
                            onChange={(e) =>
                              setSelectedCategoryId(e.target.value)
                            }
                          >
                            <option value="">اختر التصنيف الرئيسي</option>
                            {categories?.data.map((category) => (
                              <option key={category.id} value={category.id}>
                                {category.name}
                              </option>
                            ))}
                          </select>
                          <label>التصنيف الرئيسي</label>
                        </div>
                      </>
                    )}
                  />
                </div>
                <div className="col-md-6 my-3">
                  {selectedCategoryId && subCategories && (
                    <div className="form-floating">
                      <select
                        className="form-select"
                        name="sub_category_id"
                        placeholder=""
                        value={selectedSubCategoryId}
                        onChange={(e) =>
                          setSelectedSubCategoryId(e.target.value)
                        }
                      >
                        <option value="">اختر التصنيف الفرعي</option>
                        {subCategories.data.map((category) => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                      <label>التصنيف الفرعي</label>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 my-3">
                <div className="form-floating">
                  <BsEditor name="body" />
                  <label>المحتوى</label>
                </div>
              </div>
              <div className="col-12 my-3">
                <div className={"form-group p-3"}>
                  <Checkbox
                    type="checkbox"
                    name="is_summerized"
                    defaultValue={false}
                    className="slidebox"
                  >
                    خطبة مختصرة
                  </Checkbox>
                </div>
              </div>
              <div className="col-12 my-3">
                <div className={"form-group p-3"}>
                  <Checkbox
                    type="checkbox"
                    name="is_featured"
                    defaultValue={false}
                    className="slidebox"
                  >
                    خطبة مميزة
                  </Checkbox>
                </div>
              </div>
            </div>
          </ReactiveForm>
        </div>
      </div>
    </>
  );
};
